import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// import { rolesPrueba } from '../../constants/roles';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  mqttMessagesArr: null,
  loadingPagar: false,
  tipoEnvio: '',
  destino: '',
  medioPago: 0,
  seguro: false,
  medidas: {
    weight: 1,
    length: 20,
    height: 1,
    width: 10
  },
  tarifas: [],
  remitenteData: {},
  destinatarioData: {},
  envioData: {
    countryCodes: {
      country_code_from: 'MX',
      country_code_to: 'MX'
    },
    zipcodes: {
      zipcode_from: '',
      zipcode_to: ''
    },
    extraData: {
      declared_value: 0,
      description: ''
    },
    tarifaSelected: {},

    // aqui almaceno la data que me devuelve la cotizacion a redpack
    // pues despues se usa en la venta
    dataRedpackCot: {},

    // data para ser enviada
    envioItemData: {}
  },
  // envioCreated: {},
  funciones: { clientFormSubmit: null, pagoFormSubmit: null }
};

const slice = createSlice({
  name: 'dagpacketFlujo',
  initialState,
  reducers: {
    setMqttMessagesArr: (state, action) => {
      const data = action.payload;
      state.mqttMessagesArr = data;
    },

    getMedioPago: (state, action) => {
      const medioPago = action.payload;

      state.medioPago = medioPago;
    },

    getEnvioItemData: (state, action) => {
      const obj = action.payload;
      state.envioData.envioItemData = obj;
    },

    // getEnvioCreated: (state, action) => {
    //   const data = action.payload;
    //   state.envioCreated = data;
    // },

    getZipcodesAction: (state, action) => {
      const obj = action.payload;
      state.envioData.zipcodes = obj;
    },
    getExtraDataAction: (state, action) => {
      const obj = action.payload;
      state.envioData.extraData = obj;
    },

    selectTarifaAction: (state, action) => {
      const tarifa = action.payload;
      state.envioData.tarifaSelected = tarifa;
    },

    // pasar funciones por redux

    getPagoSubmitFunc: (state, action) => {
      const func = action.payload;

      state.funciones.pagoFormSubmit = func;
    },

    getClientSubmitFunc: (state, action) => {
      const func = action.payload;

      state.funciones.clientFormSubmit = func;
    },

    getDestinatarioData: (state, action) => {
      const data = action.payload;

      state.destinatarioData = { ...state.destinatarioData, ...data };
    },
    getRemitenteData: (state, action) => {
      const data = action.payload;

      state.remitenteData = { ...state.remitenteData, ...data };
    },

    // medidas

    getMedidasAction: (state, action) => {
      const data = action.payload;

      state.medidas = data;
    },

    // reset tarifas

    resetTarifas: (state) => {
      state.tarifas = [];
    },

    // data de redpack

    getRedpackDataCot: (state, action) => {
      const obj = action.payload;
      state.envioData.dataRedpackCot = obj;
    },
    // añadir tarifas
    addTarifas: (state, action) => {
      const data = action.payload;

      state.tarifas = [...state.tarifas, ...data];
    },

    tipoEnvioAction: (state, action) => {
      const tipo = action.payload;

      state.tipoEnvio = tipo;
    },

    destinoAction: (state, action) => {
      const destino = action.payload;

      state.destino = destino;
    },

    destinoCountryCodeAction: (state, action) => {
      const code = action.payload;

      state.envioData.countryCodes.country_code_to = code;
    },

    setSeguroAction: (state, action) => {
      const data = action.payload;
      console.log(data);

      state.seguro = data;
    },

    setLoadingPagar: (state, action) => {
      const value = action.payload;
      state.loadingPagar = value;
    },

    // reset state
    resetState: () => {
      // eslint-disable-next-line no-unused-expressions
      () => initialState;
    },

    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  tipoEnvioAction,
  destinoAction,
  destinoCountryCodeAction,
  setSeguroAction,
  addTarifas,
  resetTarifas,
  getRedpackDataCot,
  getDestinatarioData,
  getRemitenteData,
  getClientSubmitFunc,
  getPagoSubmitFunc,
  selectTarifaAction,
  getZipcodesAction,
  getExtraDataAction,
  getEnvioItemData,
  setLoadingPagar,
  resetState,
  getMedidasAction,
  getMedioPago,
  setMqttMessagesArr
} = slice.actions;

// ----------------------------------------------------------------------

export function getLabels() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/labels');
      dispatch(slice.actions.getLabelsSuccess(response.data.labels));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
